import { z } from 'zod';
import { optionalNullableDateInput, optionalUuidString } from '../zod-helpers/index.js';
import { MANUFACTURING_ORDER_CONSTRAINTS } from './constraints.js';
// WHY: blank locationGroupId means untouched, matching updatePurchaseOrderInput's settled decision.
export const updateManufacturingOrderInputSchema = z.object({
    locationGroupId: optionalUuidString(`Invalid ${MANUFACTURING_ORDER_CONSTRAINTS.locationGroup.label.toLowerCase()} selection.`)
        .optional()
        .nullable(),
    dateScheduled: optionalNullableDateInput,
    note: z
        .string()
        .max(MANUFACTURING_ORDER_CONSTRAINTS.note.maxLength, `${MANUFACTURING_ORDER_CONSTRAINTS.note.label} must be ${MANUFACTURING_ORDER_CONSTRAINTS.note.maxLength} characters or fewer.`)
        .optional()
        .nullable(),
});
//# sourceMappingURL=update-input.js.map